( function( $ ) {

    $(document).ready( function() {

        $('.wp-block-st-social-share .copy-link').on('click', function(e) {
            e.preventDefault();

            let link = $(this).attr('href');
            navigator.clipboard.writeText(link);

            $('.wp-block-st-social-share .copy-link .copy').hide();
            $('.wp-block-st-social-share .copy-link .copied').show();

            window.setTimeout(function() {
                $('.wp-block-st-social-share .copy-link .copied').hide();
                $('.wp-block-st-social-share .copy-link .copy').show();
            }, 2000);

        });

        $('.wp-block-st-social-share .print-page').on('click', function(e) {
            e.preventDefault();
            window.print();

        });

    } );

} )( jQuery );
